module.exports = {
	"classes": [
		"pricing-page",
		"header-dark"
	],
	"title": "Pricing",
	"metas": {
		"description": "Powerful authentication and authorization for your apps and APIs. Flexible pricing for developers and enterprises incl. a free forever dev plan."
	},
	"opengraph": {
		"og:title": "Pricing",
		"og:description": "Powerful authentication and authorization for your apps and APIs. Flexible pricing for developers and enterprises incl. a free forever dev plan.",
		"og:url": "https://auth0.com/pricing",
		"og:image": "",
		"og:image:secure_url": ""
	},
	"twittercard": {
		"twitter:title": "Pricing",
		"twitter:description": "Powerful authentication and authorization for your apps and APIs. Flexible pricing for developers and enterprises incl. a free forever dev plan.",
		"twitter:image": [
			{
				"src": ""
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/pricing/metadata.json
// module id = 1139
// module chunks = 0